module.exports = __webpack_public_path__ + "media/paper-airplane.779d140e60dc9fb3a4d6fab8c6cfe07b.svg";